<template>
  <v-layout class="app-content">
    <v-main>
      <v-card color="grey lighten-4" flat height="100%" tile>
        <v-toolbar flat height="60" class="toolbar">
          <div class="logo-128">
            <img
              v-show="show_logo"
              :src="logo"
              class="img-logo"
              alt="logo-assinatura"
            />
          </div>

          <v-toolbar-title class="pa-10">Notificação Consórcio</v-toolbar-title>

          <v-spacer></v-spacer>

          <div class="pr-10" style="padding-bottom: 2px">
            <v-tabs centered height="60">
              <v-tab class="v-tab-lil" @click="acessar(menuRoute('home'))"
                ><v-icon>icon-home</v-icon></v-tab
              >
              <v-menu
                origin="center center"
                transition="slide-y-transition"
                offset-y
              >
                <div class="arrow-up config"></div>
                <template v-slot:activator="{ on, attrs }">
                  <v-tab v-bind="attrs" v-on="on" class="v-tab-lil"
                    ><v-icon>icon-cog</v-icon></v-tab
                  >
                </template>
                <v-list class="tooltip menu-balloon">
                  <div>
                    <v-list-item @click="acessar(menuRoute('home'))">
                      <v-flex class="d-flex justify-center"
                        >Gestão de Notificações</v-flex
                      >
                    </v-list-item>
                  </div>
                  <v-divider style="border-color: white !important"></v-divider>
                  <div>
                    <v-list-item @click="emDesenvolvimento()">
                      <v-flex class="d-flex justify-center"
                        >Sincronização</v-flex
                      >
                    </v-list-item>
                  </div>
                </v-list>
              </v-menu>
              <v-menu
                origin="center center"
                transition="slide-y-transition"
                offset-y
              >
                <div class="arrow-up"></div>
                <template v-slot:activator="{ on, attrs }">
                  <v-tab v-bind="attrs" v-on="on" class="v-tab-lil"
                    ><v-icon>icon-user</v-icon></v-tab
                  >
                </template>
                <v-list class="tooltip menu-balloon">
                  <div>
                    <v-list-item @click="acessar(menuRoute('usuario'))">
                      <v-flex class="d-flex justify-center"
                        >Gestão de Usuários</v-flex
                      >
                    </v-list-item>
                  </div>
                  <v-divider style="border-color: white !important"></v-divider>
                  <div>
                    <v-list-item @click="dialogAlteraSenha = true">
                      <v-flex class="d-flex justify-center"
                        >Alterar Senha</v-flex
                      >
                    </v-list-item>
                  </div>
                  <v-divider style="border-color: white !important"></v-divider>
                  <div>
                    <v-list-item @click="logout"
                      ><v-flex class="d-flex justify-center"
                        >Sair</v-flex
                      ></v-list-item
                    >
                  </div>
                </v-list>
              </v-menu>
            </v-tabs>
          </div>
        </v-toolbar>
        <router-view :key="$route.path" />
      </v-card>
      <!-- <v-card color="grey lighten-4" flat class="d-flex justify-center">
        <div class="mb-2">
          <img
            class="pl-16"
            src="../assets/img/logo_assinatura.png"
            alt="logo-assinatura"
          />
        </div>
      </v-card> -->
    </v-main>
    <v-dialog
      v-model="dialogAlteraSenha"
      width="400"
      :scrollable="true"
      content-class="app-content"
      persistent
    >
      <v-card style="border-radius: 16px">
        <v-card-title class="text-h5">
          <v-flex class="d-flex">
            <v-flex>Alterar senha</v-flex>
            <v-menu bottom left>
              <template v-slot:activator="{ on }">
                <v-btn v-on="on" icon @click="dialogAlteraSenha = false">
                  <v-icon>fa fa-times</v-icon>
                </v-btn>
              </template>
            </v-menu>
          </v-flex>
        </v-card-title>
        <v-card-text>
          <v-form ref="form" @submit.prevent="alterarSenha">
            <v-flex mt-2>
              <v-flex>
                <label class="label-input">Senha atual *</label>
                <m-text-field
                  v-model="model.senhaAtual"
                  placeholder="Senha atual"
                  :rules="[rules.required]"
                  :type="pass_visible_atual ? 'text' : 'password'"
                  dense
                  outlined
                  validate-on-blur
                >
                  <v-icon
                    slot="append"
                    @click="pass_visible_atual = !pass_visible_atual"
                    :color="pass_visible_atual ? 'primary' : undefined"
                  >
                    {{ pass_visible_atual ? "far fa-eye" : "far fa-eye-slash" }}
                  </v-icon>
                </m-text-field>
              </v-flex>
              <v-flex mt-n2>
                <label class="label-input">Nova senha *</label>
                <m-text-field
                  v-model="model.novaSenha"
                  placeholder="Nova senha"
                  :rules="[rules.required]"
                  :type="pass_visible_nova ? 'text' : 'password'"
                  dense
                  outlined
                  validate-on-blur
                >
                  <v-icon
                    slot="append"
                    @click="pass_visible_nova = !pass_visible_nova"
                    :color="pass_visible_nova ? 'primary' : undefined"
                  >
                    {{ pass_visible_nova ? "far fa-eye" : "far fa-eye-slash" }}
                  </v-icon>
                </m-text-field>
              </v-flex>
              <v-flex mt-n2>
                <label class="label-input">Confirmar nova senha *</label>
                <m-text-field
                  v-model="model.confirmacaoNovaSenha"
                  placeholder="Confirmar senha"
                  :type="pass_visible_confirma ? 'text' : 'password'"
                  :rules="[rules.required]"
                  :error-messages="
                    validar_senha(model.novaSenha, model.confirmacaoNovaSenha)
                  "
                  dense
                  outlined
                  validate-on-blur
                >
                  <v-icon
                    slot="append"
                    @click="pass_visible_confirma = !pass_visible_confirma"
                    :color="pass_visible_confirma ? 'primary' : undefined"
                  >
                    {{
                      pass_visible_confirma ? "far fa-eye" : "far fa-eye-slash"
                    }}
                  </v-icon>
                </m-text-field>
              </v-flex>
            </v-flex>
            <v-flex>
              <v-flex>
                <v-btn
                  x-large
                  color="primary"
                  class="button btn-default white--text"
                  type="submit"
                >
                  Confirmar
                </v-btn>
              </v-flex>
            </v-flex>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import Rules from "@/plugins/validation";
import { alert, error } from "@/plugins/helpers";
import cores from "@/assets/values/colors";

export default {
  name: "Sistema",
  data: () => ({
    logo: "https://www.unifisa.com.br/wp-content/uploads/2022/01/logo.png",
    show_logo: true,
    dialogAlteraSenha: false,
    pass_visible_atual: false,
    pass_visible_nova: false,
    pass_visible_confirma: false,
    model: {
      senhaAtual: "",
      novaSenha: "",
      confirmacaoNovaSenha: "",
    },
  }),
  computed: {
    rules: () => Rules,
  },
  methods: {
    menuRoute(name) {
      try {
        const route = this.$router.resolve({ name }).route;
        const selected = this.$route.path.startsWith(route.path);
        return route.matched.length
          ? { text: route.meta.title, to: route.path, selected }
          : { text: "// fixme" };
      } catch (e) {
        return false;
      }
    },
    acessar(item) {
      if (item.click) {
        item.click();
      } else {
        try {
          if (this.$route.path !== item.to) {
            this.$router.push(item.to);
          }
        } catch (e) {
          return false;
        }
      }
    },
    logout() {
      alert({
        text: "Tem certeza que deseja sair do sistema?",
        img_topo: false,
        buttons: {
          Sair: () => {
            this.$vuetify.theme.themes.light.primary = cores.primary;
            this.$vuetify.theme.themes.light.secondary = cores.secondary;
            this.$router.replace({ name: "logout" }).catch((e) => null);
          },
          Cancelar: () => true,
        },
      });
      return false;
    },
    emDesenvolvimento() {
      alert("Funcão em desenvolvimento");
    },
    alterarSenha() {
      if (this.$refs.form.validate()) {
        if (this.model.novaSenha === this.model.confirmacaoNovaSenha) {
          this.$http
            .put("/usuario/updatePassword", this.model)
            .then((resp) => {
              alert(resp.data);
              this.dialogAlteraSenha = false;
              this.model = {
                senhaAtual: "",
                novaSenha: "",
                confirmacaoNovaSenha: "",
              };
            })
            .catch((resp) => {
              error(null, resp.response.data);
            });
        }
      }
    },
    validar_senha(senha, confirmar_senha) {
      return this.isEmpty(confirmar_senha) || senha === confirmar_senha
        ? ""
        : "As senhas não correspondem!";
    },
    isEmpty(texto) {
      return !texto || texto.length === 0;
    },
  },
};
</script>

<style scoped>
.toolbar {
  border-bottom: 1px #dddddd solid;
}

.logo-128 {
  width: 128px;
  height: 40px;
  margin-top: 10px;
  margin-left: 80px;
  margin-bottom: 10px;
}

.img-logo {
  width: 128px;
  height: 40px;
}

.config {
  margin-left: 75px !important;
}
</style>
